import React from 'react';
import { FaBell, FaUserCircle, FaSignOutAlt } from 'react-icons/fa';
import './styles/header.css';

const Header = ({ userName }) => {
  return (
    <header className="header-container">
      <div className="header-left">
        <h2>ClubManager Dashboard</h2>
      </div>
      <div className="header-right">
        <div className="header-user-info">
          <FaUserCircle className="header-icon user-icon" />
          <span className="user-name">{userName}</span>
        </div>
        <div className="header-notifications">
          <FaBell className="header-icon notification-icon" />
        </div>
        <div className="header-logout">
          <FaSignOutAlt className="header-icon logout-icon" />
          <span className="logout-text">Se Déconnecter</span>
        </div>
      </div>
    </header>
  );
};

export default Header;